import { render, staticRenderFns } from "./IconSEO.vue?vue&type=template&id=33d3d9f2&"
import script from "./IconSEO.vue?vue&type=script&lang=js&"
export * from "./IconSEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d3d9f2')) {
      api.createRecord('33d3d9f2', component.options)
    } else {
      api.reload('33d3d9f2', component.options)
    }
    module.hot.accept("./IconSEO.vue?vue&type=template&id=33d3d9f2&", function () {
      api.rerender('33d3d9f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSEO.vue"
export default component.exports